import React, {useEffect, useState} from "react";
import {useExportExcelDownload, useReadContactList} from "../hooks";
import {SubmitHandler, useForm} from "react-hook-form";
import {AccountSearchInterface} from "../../correspondent/list/interface/searchInterface";
import useGoToNavigation from "../../../../util/useGotoNavigation";
import EmptyTableRow from "../../../common/EmptyTableRow";
import useSelectCheckbox from "../../../../hooks/useSelectCheckbox";
import useDeleteContact from "../hooks/useDeleteContact";
import {PaginationMain} from "../../../../components/common/pagination/PaginationMain";
import {useSearchParams} from "react-router-dom";
import {useModal} from "../../../../hooks";
import AuthorityChecker from "../../../../components/common/authorityGuard/AuthorityChecker";

type Props = {};

export const ContactList = (props: Props) => {
    const {handleModal} = useModal();
    const page = Number(useSearchParams()[0].get("pageNo")) || 1;

    const defaultSearchValue = {
        keywordType: "0",
        keyword: "",
        limit: 10,
        pageNo: "1",
        accountId: "",
    };

    const [searchOption, setSearchOption] = useState<
        AccountSearchInterface & { accountId: string }
    >(defaultSearchValue);

    const {register, handleSubmit} = useForm({
        defaultValues: searchOption,
    });
    const {selectList, handleSelectCheckbox, isSelected, selectAll, clear} =
        useSelectCheckbox();
    const {goToNavigation} = useGoToNavigation();

    const {data} = useReadContactList({
        searchOption: searchOption,
    });

    const {mutate: downloadMutate} = useExportExcelDownload();
    const {mutate: deleteMutate} = useDeleteContact({clear});

    const onSubmit: SubmitHandler<
        AccountSearchInterface & { accountId: string }
    > = (submitData) => {
        setSearchOption(submitData);
        clear();
    };

    const dataList = data?.contactList ?? []
    const totalCount = data?.totalCount ?? 0

    useEffect(() => {
        setSearchOption({...searchOption, pageNo: page})
    }, [page]);

    return (
        <>
            <div className="fiter_wrap">
                <div className="fiter_top">
                    <h3 className="filter_heading">연락처 검색</h3>
                    <div className="filter_toolbar"></div>
                </div>
                <form className="row" onSubmit={handleSubmit(onSubmit)}>
                    <div className="col-6">
                        <div className="frm_row search justify-content-start">
                            <label htmlFor="" className="form-label frm_label">
                                검색어
                            </label>
                            <select className="form-select" {...register("keywordType")}>
                                <option value="0">전체</option>
                                <option value="1">이름</option>
                                <option value="2">회사명</option>
                                <option value="3">휴대폰</option>
                                <option value="4">회사 이메일</option>
                            </select>
                            <input
                                type="text"
                                className="form-control"
                                {...register("keyword")}
                            />
                            <button className="btn btn-info btn_search">
                                <img
                                    src={
                                        process.env.PUBLIC_URL + "/assets/images/icon_search.png"
                                    }
                                    alt=""
                                />
                                조회
                            </button>
                        </div>
                    </div>
                    <div className="col-6"></div>
                </form>
            </div>
            <div className="content_wrap">
                <div className="table_top">
                    <h6 className="table_stats">
                        연락처 목록(<span>{totalCount ?? 0}</span>건)
                    </h6>
                    <div className="table_toolbar">
                        <button
                            className="btn btn-dark w-150px px-0"
                            onClick={() => {
                                downloadMutate(searchOption);
                            }}
                        >
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/icon_export.png"}
                                alt=""
                            />
                            엑셀 내보내기
                        </button>
                        <AuthorityChecker authorityNames={['contactWriteYn']}>
                            <button
                                className="btn btn-primary w-100px px-0 ms-40px"
                                onClick={() => {
                                    goToNavigation("customer/contact/create", {}, false);
                                }}
                            >
                                연락처 생성
                            </button>
                            <button
                                className="btn btn-outline-dark w-100px px-0"
                                onClick={() => {
                                    if (selectList.length === 0) {
                                        handleModal({
                                            isOpen: true,
                                            contents: "삭제할 항목을 선택해주세요.",
                                            type: "alert"
                                        })

                                        return;
                                    }

                                    handleModal({
                                        isOpen: true,
                                        contents: "삭제하시겠습니까?",
                                        type: "confirm",
                                        callback: () => {
                                            const deleteList = dataList?.filter((item) => {
                                                if (selectList.includes(item?.contactId)) {
                                                    return item;
                                                }
                                            });

                                            if (deleteList && deleteList?.length > 0) {
                                                deleteMutate(
                                                    deleteList.map((item) => {
                                                        return {id: item?.contactId};
                                                    })
                                                );
                                            }
                                        }
                                    })
                                }}
                            >
                                <img
                                    src={process.env.PUBLIC_URL + "/assets/images/icon_cross.png"}
                                    alt=""
                                />
                                선택삭제
                            </button>
                        </AuthorityChecker>
                    </div>
                </div>
                <div className="table_scroll">
                    <table className="table table-bordered my_table">
                        <thead>
                        <tr>
                            <th style={{width: "3%"}}>
                                <div className="checkbox_outer">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        onClick={() => {
                                            if (data) {
                                                selectAll(
                                                    dataList.map((item) => {
                                                        return {...item, _id: item.contactId};
                                                    })
                                                );
                                            }
                                        }}
                                        checked={
                                            dataList && dataList?.length > 0
                                                ? dataList?.length <= selectList.length
                                                : false
                                        }
                                    />
                                </div>
                            </th>
                            <th style={{width: "8%"}}>이름</th>
                            <th style={{width: "8%"}}>직함</th>
                            <th style={{width: "12%"}}>회사명</th>
                            <th style={{width: "8%"}}>부서</th>
                            <th style={{width: "10%"}}>팀</th>
                            <th style={{width: "11%"}}>산업구분</th>
                            <th style={{width: "10%"}}>근무처 전화</th>
                            <th style={{width: "10%"}}>휴대폰</th>
                            <th style={{width: "15%"}}>회사 이메일</th>
                            {/*<th style={{width: "8%"}}>컨택 경로</th>*/}
                            <th style={{width: "5%"}}>상태</th>
                        </tr>
                        </thead>
                        <tbody>
                        {dataList?.length === 0 ? (
                            <EmptyTableRow colSpan={12}/>
                        ) : (
                            dataList?.map((item) => (
                                <tr
                                    className={isSelected({_id: item?.contactId}) ? "lightblue clickable" : "clickable"}
                                    onClick={() => {
                                        goToNavigation(
                                            "customer/contact/detail/" + item?.contactId,
                                            item,
                                            false
                                        );
                                    }}
                                >
                                    <td
                                        onClick={(e: React.MouseEvent<any>) => {
                                            e.stopPropagation();
                                        }}
                                    >
                                        <div className="checkbox_outer">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                onClick={(e: React.MouseEvent<HTMLInputElement>) => {
                                                    e.stopPropagation();
                                                    handleSelectCheckbox({
                                                        _id: item?.contactId,
                                                    });
                                                }}
                                                checked={isSelected({_id: item?.contactId})}
                                            />
                                        </div>
                                    </td>
                                    <td className="text-center">{item?.fullName}</td>
                                    <td className="text-center">{item?.jobTitle}</td>
                                    <td className="text-center">{item?.companyName}</td>
                                    <td className="text-center">{item?.department}</td>
                                    <td className="text-center">{item?.newTxtTeam}</td>
                                    <td className="text-center">{item?.industryCategory}</td>
                                    <td className="text-center">{item?.telephone1}</td>
                                    <td className="text-center">{item?.mobilePhone}</td>
                                    <td className="text-center">{item?.emailAddress1}</td>
                                    {/*<td className="text-center">{item?.contactPath}</td>*/}
                                    <td className="text-center">{item?.stateCode}</td>
                                </tr>
                            ))
                        )}
                        </tbody>
                    </table>
                </div>

                <PaginationMain totalCount={totalCount}/>
            </div>
        </>
    );
};
